export const FilterTypes = {
    LOCATION: "location",
    NUMBER: "number",
    STRING: "string",
    DATE: "date",
    CUSTOM: "custom",
    DEV_ADDRESS: "address",
    USG_RESULT: "usg",
    RESULT_STATUS: "resultStatus",
    BOOLEAN: "boolean",
    PARTURITION_LEVEL: "parturitionLevel",
    FALL_REASON: "fallReason",
    TECHNOLOGY_GROUP_REMOVAL: "technologyGroupRemoval",
    SECTOR_TYPES: "sectorTypes",
    BOARS: "boars",
    TECHNOLOGY_GROUP: "technologyGroup",
    SOW_STATE: "sowState",
    RACE: "race",
    WEEK_DAY: "weekDay",
    MONTH: "month",
    USER: "user",
    CYCLE: "cycle",
    ANIMAL_KIND: "animalKind",
    MEDICINE: "medicine",
    RACE_CODE: "raceCode",
    SUPPLIER: "supplier",
    REMOVE_REASON: "removeReason",
    ASYNC_DICTIONARY: "asyncDictionary", // tryb dzialacy tylko na tabelach duckDB, pobiera mozliwe elementy z tabeli
    SELL_REASON: "sellReason",
    SELECTION_REASON: "selectionReason",
};

export const LocationFilterTypes = {
    EVERYTHING_BELOW: "everythingBelow",
    ONLY_LOCATION: "onlyLocation",
};
